function ensure_array(value) {
  const array_value = value || [];
  return array_value;
}

export function create_handoff_drawer(config) {
  const handoff_drawer = {
    ...config,
    stats: ensure_array(config.stats),
    risk_tags: ensure_array(config.risk_tags),
    documents: ensure_array(config.documents),
    approvals: ensure_array(config.approvals),
    obligations: ensure_array(config.obligations),
    downstream: ensure_array(config.downstream)
  };
  return handoff_drawer;
}
